import { Component, computed, input } from '@angular/core';
import { PageContent } from '../page-content';
import { PageFooter } from "../../components/organism/page-footer/page-footer";
import { CfPageContentBlog } from '../../models/contentful-content-types/page-content';
import { PageHeader } from '../../components/organism/page-header/page-header';
import { Asset } from 'contentful';
import { NgComponentOutlet, NgOptimizedImage } from '@angular/common';
import { formatDate, getImageUrl } from '../../components/shared/utils';
import { CfEvent } from '../../models/contentful-content-types/event';
import { EventMap } from "../../components/molecule/event-map/event-map";
import { CfMarkdownText } from '../../models/contentful-content-types/markdown-text';
import { MarkdownText } from "../../components/molecule/markdown-text/markdown-text";

@Component({
  selector: 'app-page-content-blog',
  imports: [PageFooter, PageHeader, NgComponentOutlet, NgOptimizedImage, EventMap, MarkdownText],
  templateUrl: './page-content-blog.html',
  styles: `
    @use "../../styles/placeholder.scss" as *;

    :host {
      @extend %heroImage;
      @extend %heroTextContainer;
    }
  `
})
export class PageContentBlog extends PageContent {
  override pageContent = input<CfPageContentBlog>();

  heroImage = computed<Asset>(() => this.pageContent()?.fields?.image);
  heroImageSrc = computed<string>(() => getImageUrl(this.heroImage()));
  heroImageTitle = computed<string>(() => this.heroImage()?.fields?.title.toString());
  title = computed<string>(() => this.pageContent()?.fields?.title);
  creationDate = computed<string>(() => formatDate(this.pageContent()?.fields?.creationDate?.toString()));
  hideCreationDate = computed<boolean>(() => this.pageContent()?.fields?.hideCreationDate);
  events = computed<CfEvent[]>(() => this.pageContent()?.fields?.events);
  eventsIntroductionText = computed<CfMarkdownText>(() => this.pageContent()?.fields?.eventsIntroductionText);
  
}
